module.exports = function() {
  return new Worker(__webpack_public_path__ + "af54bb97574d47a811ae.worker.js");
};